import Error from '../common/errorData'
import CON from '../constant'
import {
  http
} from './index'
const pasurl = CON.URL_DOWN

const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}

const postReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}
export default {
// 接口提供者:
  listColumnTree: (data) => getReq('/pc-api/cms/column/select-tree', data).then(Error),
  getSingleByColumn: (data) => getReq('/pc-api/cms/content-main/getSingleByColumn', data).then(Error),
}



// WEBPACK FOOTER //
// ./src/apis/column.js